import { useSelector } from 'react-redux';

export const usePreliminaryAuthUser = () => (
  useSelector(({ authentication }) => (authentication.loggedIn ? authentication.user : null))
);
